import React from 'react'
import {
    Typography,
    Stack
  } from "@mui/material";
import { NavLink, } from 'react-router-dom';
import PaypalDonateButton from './PaypalDonateButton';

  
function Menu({darkMode}) {

    const linkClass = 'navLink ' + (darkMode ? 'dark' : undefined);

    return (
            <Typography component={"div"} className="topnav">
                <Stack direction="row" justifyContent="space-between" className="nav">
                    <NavLink className={linkClass} to="/" exact>Random Pose</NavLink>
                    <NavLink className={linkClass} to="/threesixty">360 Viewer (beta)</NavLink>
                    <NavLink className={linkClass} to="/about">About</NavLink>
                    <NavLink className={linkClass} to="/contact">Contact</NavLink>
                    <PaypalDonateButton />
                </Stack>
            </Typography>

    )
}

export default Menu
